import { QueryClient, useQuery } from '@tanstack/react-query';
import { ContestApi } from 'api/ApiHelper';
import { contestsQueryKey } from 'queries/contests/queryKey';

export const useGetContestStageQuery = (contestId: number) =>
  useQuery({
    queryKey: contestsQueryKey.contestStage(contestId),
    queryFn: () => ContestApi.getContestStage(contestId),
  });

export const prefetchContestStageQuery = (queryClient: QueryClient, contestId: number) =>
  queryClient.prefetchQuery({
    queryKey: contestsQueryKey.contestStage(contestId),
    queryFn: () => ContestApi.getContestStage(contestId),
  });

export const fetchContestStageQuery = (queryClient: QueryClient, contestId: number) =>
  queryClient.fetchQuery({
    queryKey: contestsQueryKey.contestStage(contestId),
    queryFn: () => ContestApi.getContestStage(contestId),
  });
